function Logo({ size = "md", theme = "dark" }: { size?: "sm" | "md" | "lg"; theme?: "dark" | "light" }) {
  const textSizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-5xl",
  };

  const iconHeights = {
    sm: "h-5",
    md: "h-6",
    lg: "h-10",
  };

  const isDark = theme === "dark";

  return (
    <div className="inline-flex items-center hover:scale-105 transition-transform cursor-pointer">
      <img
        src="/neo-logo.png"
        alt="NeoSearch logo"
        width={782}
        height={733}
        className={`${iconHeights[size]} w-auto`}
        loading="lazy"
      />
      <div className={`font-bold ${textSizes[size]} leading-none`}>
        <span className={isDark ? "text-white" : "text-slate-900"}>Neo</span>
        {/* orange-600: orange-500 on white is 2.8:1 — fails even the 3:1
            large-text contrast bar; 600 passes at this bold size. */}
        <span className="text-orange-600">Search</span>
      </div>
    </div>
  );
}

export default Logo;